




























































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import CopyText from '@/components/misc/CopyText.vue'
import BalanceTable from '@/components/Address/BalanceTable.vue'
import AVAXBalanceTableSummary from '@/components/Address/AVAXBalanceTableSummary.vue'
import AVAXBalanceTableDetail from '@/components/Address/AVAXBalanceTableDetail.vue'
import { IAddress, IBalanceX } from '@/services/addresses/models'
import Big from 'big.js'
import { AVAX_ID } from '@/known_assets'

@Component({
    components: {
        CopyText,
        BalanceTable,
        AVAXBalanceTableSummary,
        AVAXBalanceTableDetail,
    },
})
export default class Metadata extends Vue {
    @Prop() metaData!: IAddress
    @Prop() addressID!: string
    @Prop() alias!: string
    @Prop() assets!: IBalanceX[]
    @Prop() prefix!: string

    get AVAX(): string {
        return AVAX_ID
    }

    get assetsMap(): any {
        return this.$store.state.assets
    }

    // P-Chain AVAX balance
    get P_unlocked(): Big {
        return this.metaData.P_unlocked
    }

    get P_lockedStakeable(): Big {
        return this.metaData.P_lockedStakeable
    }

    get P_lockedNotStakeable(): Big {
        return this.metaData.P_lockedNotStakeable
    }

    get P_staked(): Big {
        return this.metaData.P_staked
    }

    // X -> P shared memory
    get XP_unlocked(): Big {
        return this.metaData.XP_unlocked
    }

    // X-Chain AVAX balance
    get X_unlocked(): Big {
        return this.metaData.X_unlocked
    }

    get X_locked(): Big {
        return this.metaData.X_locked
    }

    // X -> C shared memory
    get XC_unlocked(): Big {
        return this.metaData.XC_unlocked
    }

    // C-Chain AVAX balance
    // @dev we do not support EVM balances here. only bech32, no 0x
}
